import { createListenerMiddleware, isAnyOf, PayloadAction } from "@reduxjs/toolkit";
import { cartStoresActions } from "@/store/cartStore";
import { checkoutAction } from "@/store/checkout";
import { ECheckoutSource } from "@/utils/checkoutType";
import type { AppState } from "@/store";

export const cartTypeListenerMiddleware = createListenerMiddleware();

cartTypeListenerMiddleware.startListening({
  matcher: isAnyOf(cartStoresActions.addProduct),
  effect: (action, listenerApi) => {
    const typedAction = action as PayloadAction<Cart>;
    const isImported = typedAction.payload.details?.isImported;
    const state = listenerApi.getState() as AppState;

    const addedSource = isImported ? ECheckoutSource.INTERNATIONAL : ECheckoutSource.LOCAL;

    // Direct check: is the user currently on the checkout page?
    const isAtCheckoutPage = window.location.pathname.includes("/checkout");

    if (state.checkout.activeSource !== addedSource && !isAtCheckoutPage) {
      listenerApi.dispatch(checkoutAction.setActiveSource(addedSource));
    }
  },
});
